export default __webpack_public_path__ + "static/desk03-227f871c535074cec7abac1fe46fd9ae.png";